(() => {
  const esc = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const money = (cents) => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN', maximumFractionDigits: 0 }).format((Number(cents) || 0) / 100);
  const useLabels = { dom: 'DOMU', budowa: 'BUDOWY', warsztat: 'WARSZTATU / FIRMY', dzialka: 'DZIAŁKI / TERENU', moc: 'WIĘKSZEJ MOCY', gospodarstwo: 'GOSPODARSTWA' };
  const targets = { dom: 2.8, budowa: 5, warsztat: 5, dzialka: 2, moc: 7, gospodarstwo: 6 };

  function initWizard(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const state = { step: 1, use: '', voltage: '', start: '' };
    const steps = [...root.querySelectorAll('[data-kzw-step]')];
    const progress = [...root.querySelectorAll('.kz-wizard__progress i')];
    const next = root.querySelector('[data-kzw-next]');
    const back = root.querySelector('[data-kzw-back]');
    const nav = root.querySelector('[data-kzw-nav]');
    const result = root.querySelector('[data-kzw-result]');
    const restart = root.querySelector('[data-kzw-restart]');
    const productLink = root.querySelector('[data-kzw-product-link]');
    const products = [...root.querySelectorAll('[data-kzw-product]')].map((node) => ({
      title: node.dataset.title || '',
      model: node.dataset.model || node.dataset.title || '',
      url: node.dataset.url || '/collections/agregaty-mobilne',
      image: node.dataset.image || '',
      price: Number(node.dataset.priceCents || 0),
      power: Number(node.dataset.power || 0),
      voltage: node.dataset.voltage || '230',
      start: node.dataset.start || 'manual',
      available: node.dataset.available === 'true'
    })).filter((item) => item.power > 0);

    const currentValue = () => state.step === 1 ? state.use : state.step === 2 ? state.voltage : state.start;

    function sync() {
      steps.forEach((step) => { step.hidden = Number(step.dataset.kzwStep) !== state.step; });
      progress.forEach((bar, index) => {
        bar.classList.toggle('is-complete', index + 1 < state.step);
        bar.classList.toggle('is-active', index + 1 === state.step);
      });
      back.hidden = state.step === 1;
      next.disabled = !currentValue();
      next.textContent = state.step === 3 ? 'Pokaż rekomendację →' : 'Dalej →';
      result.hidden = true;
      nav.hidden = false;
    }

    function compatible(list, voltage, start) {
      let filtered = list.filter((item) => item.voltage === voltage);
      if (start !== 'any') {
        const exact = filtered.filter((item) => item.start === start);
        if (exact.length) filtered = exact;
      }
      return filtered;
    }

    function chooseProducts() {
      const voltage = state.voltage === 'unknown' ? '230' : state.voltage;
      const target = targets[state.use] || 2.8;
      let pool = compatible(products, voltage, state.start);
      if (!pool.length) pool = products.filter((item) => item.voltage === voltage);
      pool.sort((a, b) => a.power - b.power || a.price - b.price);

      const sufficient = pool.filter((item) => item.power + 0.001 >= target);
      const main = sufficient[0] || pool[pool.length - 1] || null;
      if (!main) return { main: null, cheaper: null, reserve: null, voltage, target };

      const lower = pool.filter((item) => item.power < main.power - 0.001).sort((a, b) => b.power - a.power || a.price - b.price);
      let cheaper = lower[0] || pool.filter((item) => item.power === main.power && item.url !== main.url).sort((a, b) => a.price - b.price)[0] || null;
      const higher = pool.filter((item) => item.power > main.power + 0.001).sort((a, b) => a.power - b.power || a.price - b.price);
      let reserve = higher[0] || pool.filter((item) => item.url !== main.url && (!cheaper || item.url !== cheaper.url)).sort((a, b) => b.power - a.power || a.price - b.price)[0] || null;

      if (cheaper && reserve && cheaper.url === reserve.url) reserve = null;
      return { main, cheaper, reserve, voltage, target };
    }

    function voltageText(value) {
      return value === 'dual' ? 'Dual Power 230/400 V' : value === '400' ? '400 V' : '230 V';
    }

    function startText(value) {
      return value === 'electric' ? 'rozruch elektryczny' : 'rozruch ręczny';
    }

    function mainCard(item) {
      if (!item) return '<div class="kz-wizard__empty">Nie znaleźliśmy modelu spełniającego ten zestaw warunków. Skontaktuj się z doradcą KRUZER.</div>';
      return `
        <div class="kz-rec-main">
          <div class="kz-rec-main__image">${item.image ? `<img src="${esc(item.image)}" alt="${esc(item.model)}" loading="lazy">` : ''}</div>
          <div>
            <span class="kz-rec-main__badge">Najlepszy wybór</span>
            <h4>KRUZER ${esc(item.model)}</h4>
            <p>${String(item.power).replace('.', ',')} kW · ${esc(voltageText(item.voltage))}<br>${esc(startText(item.start))} · AVR</p>
            <strong>${money(item.price)}</strong>
          </div>
        </div>`;
    }

    function altCard(item, label) {
      if (!item) return `<div class="kz-rec-alt"><small>${esc(label)}</small><b>Dobór indywidualny</b><strong>Zapytaj doradcę</strong></div>`;
      return `<div class="kz-rec-alt"><small>${esc(label)}</small><b><a href="${esc(item.url)}">KRUZER ${esc(item.model)} · ${String(item.power).replace('.', ',')} kW</a></b><strong>${money(item.price)}</strong></div>`;
    }

    function noteText(selection) {
      if (!selection.main) return 'Ten zestaw wymaga indywidualnego doboru. Zadzwoń: 531 026 666.';
      const unknown = state.voltage === 'unknown' ? ' Ponieważ nie wskazałeś napięcia, przyjęliśmy 230 V.' : '';
      const context = state.use === 'dzialka'
        ? 'Na działkę liczy się mobilność i spokojna praca, dlatego nie podnosimy mocy bez potrzeby.'
        : state.use === 'moc' || state.use === 'gospodarstwo'
          ? 'Dla kilku odbiorników, pomp lub chłodni zostawiamy większą rezerwę mocy.'
          : 'Dobór uwzględnia rozsądny zapas mocy bez automatycznego przepłacania za większy model.';
      return `${context}${unknown} Ostateczny dobór warto potwierdzić na podstawie listy urządzeń.`;
    }

    function showResult() {
      const selection = chooseProducts();
      steps.forEach((step) => { step.hidden = true; });
      progress.forEach((bar) => { bar.classList.add('is-complete'); bar.classList.remove('is-active'); });
      nav.hidden = true;
      result.hidden = false;
      root.querySelector('[data-kzw-result-label]').textContent = `✓ REKOMENDACJA DLA: ${useLabels[state.use] || 'TWOICH POTRZEB'}`;
      root.querySelector('[data-kzw-main]').innerHTML = mainCard(selection.main);
      root.querySelector('[data-kzw-cheaper]').innerHTML = altCard(selection.cheaper, 'Tańsza, jeśli wystarczy');
      root.querySelector('[data-kzw-reserve]').innerHTML = altCard(selection.reserve, 'Większy zapas');
      root.querySelector('[data-kzw-note]').textContent = noteText(selection);
      if (selection.main) {
        productLink.href = selection.main.url;
        productLink.textContent = `Zobacz ${selection.main.model} →`;
      } else {
        productLink.href = 'mailto:bok@kruzer.pl?subject=Pomoc%20w%20doborze%20agregatu';
        productLink.textContent = 'Zapytaj doradcę →';
      }
    }

    root.addEventListener('click', (event) => {
      const option = event.target.closest('[data-kzw-value]');
      if (option && option.closest('[data-kzw-step]')) {
        const step = Number(option.closest('[data-kzw-step]').dataset.kzwStep);
        option.closest('[data-kzw-step]').querySelectorAll('[data-kzw-value]').forEach((button) => button.classList.toggle('is-selected', button === option));
        if (step === 1) state.use = option.dataset.kzwValue;
        if (step === 2) state.voltage = option.dataset.kzwValue;
        if (step === 3) state.start = option.dataset.kzwValue;
        next.disabled = false;
      }
    });

    next.addEventListener('click', () => {
      if (!currentValue()) return;
      if (state.step < 3) { state.step += 1; sync(); }
      else showResult();
    });

    back.addEventListener('click', () => {
      if (state.step > 1) { state.step -= 1; sync(); }
    });

    restart.addEventListener('click', () => {
      state.step = 1; state.use = ''; state.voltage = ''; state.start = '';
      root.querySelectorAll('[data-kzw-value]').forEach((button) => button.classList.remove('is-selected'));
      sync();
    });

    document.querySelectorAll('[data-kzw-preset]').forEach((link) => {
      link.addEventListener('click', () => {
        state.step = 1;
        state.use = link.dataset.kzwPreset || '';
        state.voltage = '';
        state.start = '';
        root.querySelectorAll('[data-kzw-value]').forEach((button) => button.classList.remove('is-selected'));
        const preset = root.querySelector(`[data-kzw-step="1"] [data-kzw-value="${CSS.escape(state.use)}"]`);
        if (preset) preset.classList.add('is-selected');
        sync();
        setTimeout(() => root.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
      });
    });

    sync();
  }

  function init() {
    document.querySelectorAll('[data-kzw]').forEach(initWizard);
    const sticky = document.querySelector('.kz [data-sticky]');
    if (sticky) window.addEventListener('scroll', () => sticky.classList.toggle('show', window.scrollY > 700), { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
